import React, { useEffect, useState } from "react";
import Toggle from 'theme/Toggle';
import Text from "theme/Text";
import ThemedBlock from 'components/atoms/ThemedBlock'
import { StyleSheet, View } from 'react-native'
import i18n from 'utils/i18n'
import WorkdayInput from 'scenes/home/more/workdays/_tabs/_components/WorkdayInput'
import EmployeeValues from 'scenes/home/more/_functions/Employee'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { constantsActive } from 'utils/constants/constants'
import { TESTID } from '_shared/config/testID'
import HelperTestID from 'utils/HelperTestID'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'
import ThemedToggle from "components/atoms/ThemedToggle";

const WorkdaysTab = () => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const [ vacationActive, setVacationActive ] = useState( _.get( _employee, 'vacation_mode_active', 'no' ) === constantsActive.YES )
	
	const onChangeDay = ( value ) => {
		const _workdays = _.reject( EmployeeValues.getEmployeeField( _employee, 'workdays', [] ), { workday_day: value.workday_day } )
		
		EmployeeValues.onChangeEmployee({
			workdays: [
				..._workdays,
				value
			],
			vacation_mode_active: vacationActive ? constantsActive.YES : constantsActive.NO
		});
	}
	
	useEffect( () => {
		EmployeeValues.onChangeEmployee({
			vacation_mode_active: vacationActive ? constantsActive.YES : constantsActive.NO
		})
	}, [ vacationActive ] );
	
	const days = [];
	for( let day = 1; day <= 7; day++ ) {
		days.push(
			<WorkdayInput
				onChange={ onChangeDay }
				day={ day }
				forceDisabled={ vacationActive }
				testID={ HelperTestID.generate( TESTID.HOME.MORE.WORKDAYS.DAY_COMPONENT, day ) }
			/>
		)
	}
	
	return (
		<View testID={ TESTID.HOME.MORE.WORKDAYS.VIEW }>
			<VStack
				space={ ThemedValues.stackSpace }>
				
				<ThemedBlock
					mediumPadding
					shadow>
					
					<Text category="p1">
						{ i18n.t('page.workdays.introduction') }
					</Text>
				</ThemedBlock>
				
				<ThemedBlock
					mediumPadding
					shadow>
					
					<View style={staticStyles.viewFlexDirectionRow}>
						<View style={ staticStyles.viewJustifyContentCenterFlex2 }>
							<ThemedToggle
								checked={ vacationActive }
								onPress={ setVacationActive.bind( this, !vacationActive ) }
								testID={ TESTID.HOME.MORE.WORKDAYS.OUTOFOFFICE_TOGGLE }>
								
								{ i18n.t('page.workdays.vacation_mode') }
							</ThemedToggle>
						</View>
					</View>
				</ThemedBlock>
				
				{ !vacationActive && (
					<ThemedBlock
						shadow
						mediumPadding
						testID={ TESTID.HOME.MORE.WORKDAYS.WORKINGDAYS_VIEW }>
						
						<Text category="s1" style={ staticStyles.textMarginBottom8 }>{ i18n.t( 'titles.more_workdays') }</Text>
						
						{ days }
					</ThemedBlock>
				)}
			</VStack>
		</View>
	)
}

const staticStyles = StyleSheet.create({
	viewFlexDirectionRow: {
		flexDirection: 'row',
	},
	viewJustifyContentCenterFlex2: {
		justifyContent: 'center',
		flex: 2,
	},
	textMarginBottom8: {
		marginBottom: 8,
	},
});

export default WorkdaysTab
